/** Desafio de uso único (5 min) devolvido pelas rotas `/opcoes`. */
export interface DesafioBiometria<TOpcoes> {
  desafioId: string
  opcoes: TOpcoes
}

export type DesafioCadastro = DesafioBiometria<PublicKeyCredentialCreationOptionsJSON>
export type DesafioConfirmacao = DesafioBiometria<PublicKeyCredentialRequestOptionsJSON>

export interface AparelhoBiometria {
  id: string
  nomeDispositivo: string
  criadoEm: string
  ultimoUsoEm: string | null
  /** Só no cadastro: a sessão atual passou a exigir esta biometria. */
  sessaoVinculada?: boolean
}

export interface CadastroAparelhoPayload {
  desafioId: string
  nomeDispositivo: string
  resposta: RegistrationResponseJSON
}

export interface ConfirmacaoPayload {
  desafioId: string
  resposta: AuthenticationResponseJSON
}

/** Mesmo formato do token do PIN: vale 2 minutos e só pode ser usado uma vez. */
export interface ConfirmacaoBiometria {
  token: string
  expiraEm: string
}

/** `errorCode` do 403 (falha na verificação, desafio vencido/usado ou aparelho de outro usuário). */
export const BIOMETRIA_INVALIDA = 'BIOMETRIA_INVALIDA'

/** `errorCode` do 409 quando a operação exige biometria e o usuário não tem aparelho cadastrado. */
export const BIOMETRIA_NAO_CADASTRADA = 'BIOMETRIA_NAO_CADASTRADA'
